export default __webpack_public_path__ + "static/media/banner_w1024.e0c22231.jpeg";